/*
 * Module for user menu
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/header/userMenu/userMenuView",
], function (Marionette, Backbone, Messenger, UserMenuView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "userMenu";
      this.region = options.region;
      this.showAdmin = options.showAdmin;
      this.loggingOut = false;
      this._setUpVents();
    },
    show: function () {
      let user = Messenger.reqres.request("user"); //get user model
      const kbModel = Messenger.reqres.request("active:kb:model");
      user.isAdmin = user.get("admin");
      user.showAdmin = this.showAdmin;
      user.kb = kbModel;

      const kbId = kbModel.get("kbId");
      const kbDefaults = user.get("kbDefaults");
      let kbDefault;
      for (let i = 0; i < kbDefaults.length; i++) {
        if (kbDefaults[i].id === kbId) {
          kbDefault = kbDefaults[i];
        }
      }

      if (!kbModel.isSynced) {
        kbModel.once(
          "sync",
          function () {
            this.view.render();
          },
          this,
        );
      }

      this.view = new UserMenuView.userMenuView({ model: user });
      this.view.on(
        "logout",
        function () {
          this.view.hideDropdown();
          Messenger.save(function (success) {
            if (success) {
              this.loggingOut = true;
              Messenger.vent.trigger("logout");
            }
          }, this);
        },
        this,
      );
      //configure user
      this.view.on(
        "config",
        function () {
          this.view.hideDropdown();
          Messenger.save(function (success) {
            if (success) {
              // If the user accessed the account administration directly from the URL, then the active KB will need to be
              // set when navigating away
              if (!Messenger.reqres.request("active:kb")) {
                const kbId = Messenger.reqres.request("default:kbId");
                Messenger.command.execute("set:active:kb", kbId);
              }

              Messenger.command.execute("change:menu", null); //deselect current menu item
              Messenger.vent.trigger("toggle:home:button", false); //deselect home button
              Messenger.vent.trigger("show:admin");
              Messenger.vent.trigger("toggle:header", true);
            }
          }, this);
        },
        this,
      );
      //configure APIs
      this.view.on("api:admin", () => {
        this._showAuthoringAdmin("apis");
      });
      //configure attributes
      this.view.on("attribute:admin", () => {
        this._showAuthoringAdmin("attributes");
      });
      //configure categories
      this.view.on("category:admin", () => {
        this._showAuthoringAdmin("categories");
      });
      //configure campaigns
      this.view.on("campaign:admin", () => {
        this._showAuthoringAdmin("campaigns");
      });
      //configure variables
      this.view.on("variable:admin", () => {
        this._showAuthoringAdmin("conversationVariables");
      });
      //configure account
      this.view.on(
        "account:admin",
        function () {
          Messenger.save(function (success) {
            if (success) {
              Messenger.command.execute("change:menu", null); //deselect current menu item
              Messenger.vent.trigger("toggle:home:button", false); //deselect home button
              Messenger.vent.trigger("toggle:header", false);
              Backbone.history.navigate("accountAdmin", { trigger: true });
            }
          }, this);
        },
        this,
      );
      //configure site maps
      this.view.on("siteMap:admin", () => {
        this._showAuthoringAdmin("siteMaps");
      });
      //configure table of contents
      this.view.on("tableOfContents:admin", () => {
        this._showAuthoringAdmin("tableOfContents");
      });
      //configure topic listing utility
      this.view.on("topicListing:admin", () => {
        this._showAuthoringAdmin("topicListing");
      });
      this.showRegion(this.view);
    },
    _showAuthoringAdmin: function (selectedMenuItem) {
      Messenger.save(function (success) {
        if (success) {
          Messenger.command.execute("change:menu", null); //deselect current menu item
          Messenger.vent.trigger("toggle:home:button", false); //deselect home button
          Messenger.vent.trigger("show:authoring:admin", selectedMenuItem);
        }
      });
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "toggle:admin:button",
        function (selected) {
          if (selected) {
            this.view.activateAdminButton();
          } else {
            this.view.deactivateAdminButton();
          }
        },
        this,
      );
      Messenger.vent.on(
        "kb:changed",
        function () {
          const kbModel = Messenger.reqres.request("active:kb:model");
          this.view.model.kb = kbModel;
          kbModel.onSynced(function () {
            this.view.render();
          }, this);
        },
        this,
      );
      Messenger.vent.on(
        "app:close",
        function (status) {
          status.logout = this.loggingOut;
        },
        this,
      );
    },
  });
});
